import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, ArrowRightIcon, UserIcon, ExternalLinkIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { getAllPosts, formatDate, BlogPost } from '../data/blogPosts';
const BlogPostCard: React.FC<{
  post: BlogPost;
  index: number;
}> = ({
  post,
  index
}) => {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.1 * index,
    duration: 0.3
  }} data-id="element-161">
      <a href={post.substackUrl} target="_blank" rel="noopener noreferrer" className="block bg-background-light border-2 border-gray-800 rounded-lg overflow-hidden hover:border-primary transition-all group" data-id="element-162">
        <div className="p-6" data-id="element-163">
          <div className="flex items-center gap-4 text-sm text-text-secondary mb-3" data-id="element-164">
            <div className="flex items-center gap-2" data-id="element-165">
              <CalendarIcon className="h-4 w-4" data-id="element-166" />
              <time dateTime={post.publishedAt} data-id="element-167">
                {formatDate(post.publishedAt)}
              </time>
            </div>
            <div className="flex items-center gap-2" data-id="element-168">
              <UserIcon className="h-4 w-4" data-id="element-169" />
              <span data-id="element-170">{post.author.name}</span>
            </div>
          </div>
          <div className="flex items-start justify-between gap-3 mb-3" data-id="element-171">
            <h2 className="text-2xl font-bold text-text-primary group-hover:text-primary transition-colors" data-id="element-172">
              {post.title}
            </h2>
            <ExternalLinkIcon className="h-5 w-5 text-text-secondary group-hover:text-primary transition-colors flex-shrink-0 mt-1" data-id="element-173" />
          </div>
          <p className="text-text-secondary mb-4 line-clamp-3" data-id="element-174">
            {post.excerpt}
          </p>
          <div className="flex items-center gap-2 text-primary font-semibold" data-id="element-175">
            <span data-id="element-176">Read on Substack</span>
            <ArrowRightIcon className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-177" />
          </div>
        </div>
      </a>
    </motion.article>;
};
export const BlogPage: React.FC = () => {
  const posts = getAllPosts();
  return <div className="min-h-screen flex flex-col bg-background" data-id="element-178">
      <Helmet data-id="element-179">
        <title data-id="element-180">Blog - IBD Rant</title>
        <meta name="description" content="Stories, insights, and updates from the IBD community." data-id="element-181" />
        <meta property="og:type" content="website" data-id="element-182" />
        <meta property="og:title" content="Blog - IBD Rant" data-id="element-183" />
        <meta property="og:description" content="Stories, insights, and updates from the IBD community." data-id="element-184" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-185" />
        <meta name="twitter:title" content="Blog - IBD Rant" data-id="element-186" />
        <meta name="twitter:description" content="Stories, insights, and updates from the IBD community." data-id="element-187" />
      </Helmet>
      <Header data-id="element-188" />
      <main className="flex-grow py-12 px-4 bg-background" data-id="element-189">
        <div className="max-w-4xl mx-auto" data-id="element-190">
          <motion.div className="text-center mb-16" initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-191">
            <motion.div className="flex items-center justify-center gap-3 mb-4" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-192">
              <BookOpenIcon className="h-8 w-8 text-primary" data-id="element-193" />
              <h1 className="text-3xl md:text-4xl font-bold" data-id="element-194">IBD Rant Blog</h1>
            </motion.div>
            <motion.p className="text-text-secondary text-lg" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} data-id="element-195">
              Stories, insights, and updates from the IBD community
            </motion.p>
          </motion.div>

          <div className="space-y-8" data-id="element-196">
            {posts.map((post, index) => <BlogPostCard key={post.id} post={post} index={index} data-id="element-197" />)}
          </div>
        </div>
      </main>
      <Footer data-id="element-198" />
    </div>;
};